module.exports = __webpack_public_path__ + "img/changan.f2df3cff.png";